import { IDrainageDefect } from "../data/drainageForm/types";

export const initialValuesDrainage: IDrainageDefect = {
  mediaCoverage: false,
  mediaComment: null,
  addressGuid: null,
  organizationId: null,
  objectId: null,
  incidentStatusId: null,
  objectTypeId: null,
  classifierTypeId: null,
  objectShortName: "",
  statusComment: "",
  districtId: null,
  addressText: null,
  dateTimeDisable: null,
  dateTimePlanned: null,
  dateTimeEnable: null,
  timeDisable: "",
  gasPlannedTime: "",
  timeEnable: "",
  disconnectedSubscribers: null,
  responsible: null,
  responsiblePhone: null,
  comment: "",
  eventTypeId: null,
  gridTypeId: 5,
  overBuildings: null,
  livingBuildings: null,
  hospitalBuildings: null,
  childrenBuildings: null,
  buildings: null,
  typeGasketId: null,
  diameter: null,
  discharge: false,
  defNatureId: null,
  standartTime: null,
  addressNote: "",
  complaintCodeId: null,
  workProgressId: null,
  workStatusId: null,
  externalSystemId: 1,
  involvedResource: null,
  precipitation: null,
  externalId: null,
  repairCategoryId: null,
  files: [],
  addressAreaId: null,

  mkaDecisionStatusId: null,
  fullOfMkdCount: null,
  partialOfMkdCount: null,
  connectedOfMkdCount: null,
  shouldBeSendToMka: false,

  municipalityText: "",
  mkaUtilitiesSectorId: null,
  incidentDescription: null,
  parentId: null,
  mkaTechonologicalProcessStageId: null,
  mkaObjectKindId: null,
  mkaObjectType: null,
  mkaObjectName: null,
  mkaIncidentTypeId: null,
  deadCount: null,
  affectedCount: null,
  weather: null,
  fullFact: false,
  fullListOfLocation: null,
  fullListOfObjects: null,
  fullOfSocialObjectsCount: null,
  fullListOfMkd: [],
  fullOfMkdPplCount: null,
  fullOfPrivateHousesCount: null,
  fullOfPrivateHousesPplCount: null,
  fullListOfObjectsOther: null,
  partialFact: false,
  partialListOfLocation: null,
  partialListOfObjects: null,
  partialOfSocialObjectsCount: null,
  partialListOfMkd: [],
  partialOfMkdPplCount: null,
  partialOfPrivateHousesCount: null,
  partialOfPrivateHousesPplCount: null,
  partialListOfObjectsOther: null,
  connectedFact: false,
  connectedListOfCommunalServices: null,
  connectedListOfLocation: null,
  connectedListOfObjects: null,
  connectedOfSocialObjectsCount: null,
  connectedListOfMkd: [],
  connectedOfMkdPplCount: null,
  connectedOfPrivateHousesCount: null,
  connectedOfPrivateHousesPplCount: null,
  connectedListOfObjectsOther: null,
  objectOwnerName: null,
  operatingOrganizationName: null,
  planResponsibles: null,
  additionalInformation: null,
  operationalInformationSource: null,
};
